import React, { useEffect, useState } from 'react';
import StandardCard from '../StandardCard';
import { Toast } from 'antd-mobile';
import ChangeLog from '../ChangeLog';
import { getPublishedFiles } from '../../services/services';
// import { IntlProvider } from 'react-intl';
import { FormattedMessage } from 'react-intl';
import { lang } from '../../config/config';
import styles from './index.module.css';

// 手册下载链接配置
const HANDBOOK_DOWNLOAD_LINKS = {
  // 工业数字化手册
  IndustrialDigitalization_handbook: {
    china: [
      {
        name: '工业数字化产品合集',
        url: 'https://www.inhand.com.cn/wp-content/uploads/Industrial-digitalization.pdf',
      },
      {
        name: '边缘智能解决方案',
        url: 'https://www.inhand.com.cn/wp-content/uploads/Edge-Intelligence-Solution.pdf',
      },
    ],
    global: [
      {
        name: 'Product Catalog - Industrial IoT',
        url: 'https://www.inhand.com/wp-content/uploads/product-catalog_industrial-iot.pdf',
      },
      {
        name: 'Brochure - InHand Edge Intelligence Solution',
        url: 'https://www.inhand.com/wp-content/uploads/inhand-edge-intelligence-solution.pdf',
      },
    ],
  },
  // 企业网络手册
  EnterpriseNetwork_handbook: {
    china: [
      {
        name: '企业网络解决方案',
        url: 'https://www.inhand.com.cn/wp-content/uploads/enterprise-network.pdf',
      },
    ],
    global: [
      {
        name: 'Brochure - Enterprise Network',
        url: 'https://www.inhand.com/wp-content/uploads/inhand-enterprise-network.pdf',
      },
    ],
  },
  // 智慧商业手册
  SmartCommerce_handbook: {
    china: [
      {
        name: '智慧新零售产品合集',
        url: 'https://www.inhand.com.cn/wp-content/uploads/smart-commerce.pdf',
      },
    ],
    global: [
      {
        name: 'InHandGo Grab & Go AI Vending Cooler',
        url: 'https://www.inhand.com/wp-content/uploads/inhandgo-grab-n-go-ai-vending-cooler.pdf',
      },
      {
        name: 'Smart Vending System',
        url: 'https://www.inhand.com/wp-content/uploads/inhand-smart-vending-system.pdf',
      },
    ],
  },
  // 数字能源手册
  DigitalEnergy_handbook: {
    china: [
      {
        name: '智能化配电网线路状态监测系统',
        url: 'https://www.inhand.com.cn/wp-content/uploads/intelligent-wireless-observing-system.pdf',
      },
    ],
    global: [
      {
        name: 'IWOS Brochure',
        url: 'https://www.inhand.com/wp-content/uploads/iwos.pdf',
      },
    ],
  },
  // 移动性手册
  Mobility_handbook: {
    china: [
      {
        name: '车载与运输产品合集',
        url: 'https://www.inhand.com.cn/wp-content/uploads/mobility.pdf',
      },
    ],
    global: [
      {
        name: 'Product Catalog - Mobility',
        url: 'https://www.inhand.com/wp-content/uploads/product-catalog_mobility.pdf',
      },
    ],
  },
};

export default function FilesGroup({ paramsObj, name }) {
  const { category, product_category, series_id } = paramsObj;
  const [files, setFiles] = useState([]);
  console.log(product_category, 'product_category');

  // 检查是否是手册类型
  const isHandbook = categoryId => {
    return categoryId?.toLowerCase().includes('handbook');
  };

  // 检查是否是 Use Cases 类型
  const isUseCases = categoryId => categoryId === 'Use Cases';

  // 按 subcategory_desc 分组（Use Cases 专用）
  const groupBySubcategoryDesc = files => {
    return files.reduce((acc, file) => {
      const key = file.subcategory_desc || '其他';
      if (!acc[key]) acc[key] = [];
      acc[key].push(file);
      return acc;
    }, {});
  };

  // 获取手册文件列表
  const getHandbookFiles = handbookKey => {
    const islang = lang === 'en' ? 'global' : 'china'; // 假设默认语言为中文
    if (HANDBOOK_DOWNLOAD_LINKS[handbookKey]?.[islang]) {
      return HANDBOOK_DOWNLOAD_LINKS[handbookKey][islang].map(item => ({
        name: item.name,
        external_url: item.url,
        size: '0', // 或者可以设置一个默认大小
        release_date: new Date().toISOString(), // 使用当前日期或者设置固定日期
        category: 'xuanchuan',
      }));
    }
    return [];
  };

  useEffect(() => {
    let ignore = false;

    async function fetchFiles() {
      // 如果是手册类型，直接设置手册数据
      if (isHandbook(product_category)) {
        const handbookFiles = getHandbookFiles(product_category);
        if (!ignore) {
          setFiles(handbookFiles);
        }
        return;
      }

      // 常规文件获取逻辑
      if (!category || !product_category || !series_id) return;

      try {
        const res = await getPublishedFiles({
          category,
          product_category,
          series_id,
        });

        if (res.status === 200 && !ignore) {
          setFiles(res.result);
        } else if (!ignore) {
          Toast.show({
            content: res.error,
            duration: 3000,
          });
        }
      } catch (error) {
        if (!ignore) {
          Toast.show({
            content: '获取文件列表失败',
            duration: 3000,
          });
        }
      }
    }

    fetchFiles();

    return () => {
      ignore = true;
    };
  }, [category, product_category, series_id]);

  if (files.length === 0) return null;

  return (
    <div style={{ padding: 24 }}>
      <div className={styles.header}>
        {isHandbook(product_category) ? (
          <FormattedMessage id='handbook' />
        ) : (
          name
        )}
      </div>
      <div className={styles.content}>
        {files.length > 0 && category === 'firmware' && (
          <ChangeLog series_id={series_id} />
        )}
        {isUseCases(category) ? (
          Object.entries(groupBySubcategoryDesc(files)).map(([subcategory, groupFiles]) => (
            <div key={subcategory} className={styles.useCasesGroup}>
              <div className={styles.useCasesGroupTitle}>{subcategory}</div>
              {groupFiles.map((item, index) => (
                <StandardCard
                  key={index}
                  data={item}
                  category={category}
                />
              ))}
            </div>
          ))
        ) : (
          files.map((item, index) => (
            <StandardCard
              key={index}
              data={item}
              category={isHandbook(product_category) ? 'xuanchuan' : category}
            />
          ))
        )}
      </div>
    </div>
  );
}
